import { Lock } from "lucide-react";

import { cn } from "../../lib/utils.js";
import { Badge } from "../ui/badge.js";

// Replaces an employee's upload control once HR has verified the document:
// it can still be viewed (version history), but not replaced. The server
// enforces the same lock (409 from documents.service).
export function DocumentLockedNotice({ className }: { className?: string }) {
  return (
    <div className={cn("flex flex-wrap items-center gap-2", className)}>
      <Badge tone="success" className="gap-1"><Lock size={12} /> Verified — locked</Badge>
      <span className="text-xs text-surface-500">HR has verified this document. Contact HR if it needs to change.</span>
    </div>
  );
}
